import * as z from "zod";

export const getMerchantDnsValues = {
  name: "getMerchantDnsValues" as const,
  input: z.object({ email: z.string().email() }),
  output: z.object({
    redirectEmail: z.string(),
    dkimHost: z.string(),
    dkimText: z.string(),
    returnPathDomain: z.string(),
    returnPathValue: z.string(),
    setupStatus: z.string(),
  }),
};
